export default __webpack_public_path__ + "static/media/profile-christ.853a654d.png";